import { Component } from '@angular/core';

@Component({
  selector: 'sbr-brief-management',
  standalone: true,
  imports: [],
  templateUrl: './brief-management.component.html',
  styleUrl: './brief-management.component.css'
})
export class BriefManagementComponent {

}
